import { render, staticRenderFns } from "./GovernanceConstructionSharing.vue?vue&type=template&id=61fa932a&scoped=true&"
import script from "./GovernanceConstructionSharing.vue?vue&type=script&lang=js&"
export * from "./GovernanceConstructionSharing.vue?vue&type=script&lang=js&"
import style0 from "./GovernanceConstructionSharing.vue?vue&type=style&index=0&id=61fa932a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa932a",
  null
  
)

export default component.exports